import React from 'react';

const Footer = () => {
    return (
        <div className="app-footer" >
            <footer class="container" style={{width:'auto', height:'60px', padding:'20px'}}>
                <p style={{textJustify:'center', fontSize:'14pt', color:'white'}} >&copy; Rachmat Gunawan 2020</p>
            </footer>
        </div>
    )
}
export default Footer;